var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgMicrosoftLogo = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 33 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 32,
  height: 32,
  rx: 16,
  fill: "#fff"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#microsoftLogo_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.153 16.152H9.5V9.5h6.653v6.652Z",
  fill: "#F1511B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.5 16.152h-6.654V9.5H23.5v6.652Z",
  fill: "#80CC28"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.153 23.5H9.5v-6.652h6.653V23.5Z",
  fill: "#00ADEF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.5 23.5h-6.654v-6.652H23.5V23.5Z",
  fill: "#FBBC09"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "microsoftLogo_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(9.5 9.5)",
  d: "M0 0h14v14H0z"
})))));

const ForwardRef = /*#__PURE__*/forwardRef(SvgMicrosoftLogo);
export default ForwardRef;